import React from "react";

export default function NotFound() {
    return (
        <React.Fragment>
            <h1>Oops... Looks like you have the wrong link</h1>
        </React.Fragment>
    );
}
